import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const SuggestDesignation = lazy(() => import('./SuggestDesignation')) 

const PriorityRoutes = [
    {
        path: '/SuggestDesignation',
        component: SuggestDesignation,
        auth: authRoleAccess.suggest_designation,
    },
   
]

export default PriorityRoutes 